import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'
import hy from './locales/hy.json'

const i18n = createI18n({
  legacy: false,
  locale: 'hy',
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
    hy,
  },
})

export default i18n
